const domainSettings = {
	description: "Wijzig hier de instellingen voor het domein",
	domain_name_idn: {
		label: "Is het een IDN-domein?",
	},
	domain_name_max_length: {
		label: "Maximaal aantal karakters domein",
		placeholder: "Geef het maximaal aantal verplichte karakters op.",
	},
	domain_name_max_period: {
		label: "Maximale verlengperiode",
		placeholder: "Selecteer de maximale verlengperiode voor dit domein",
	},

	// DOMAIN VALIDATION
	domain_name_min_length: {
		label: "Minimaal aantal karakters domein",
		placeholder: "Geef het minimaal aantal verplichte karakters op.",
	},
	domain_name_min_period: {
		label: "Minimale verlengperiode",
		placeholder: "Selecteer de minimale verlengperiode voor dit domein",
	},
	domain_name_numeric_only: {
		label: "Alleen numerieke waardes?",
	},

	// RENEWAL SETTINGS
	domain_name_renewal_period: {
		label: "Verlengperiode",
		placeholder: "Selecteer de verlengperiode voor dit domein",
	},
	nameserver_max_amount: {
		label: "Maximaal aantal nameservers",
		placeholder: "Selecteer het maximaal aantal nameservers",
	},

	// NAMESERVERS
	nameserver_min_amount: {
		label: "Minimaal aantal nameservers",
		placeholder: "Selecteer het minimaal aantal nameservers",
	},
	prices_explanation: `
**De getoonde prijzen zijn voor intern gebruik!** De uiteindelijke verkoopprijs wordt als volgt berekend:
- Verhuizing en wijziging: Hoogste prijs wordt gekozen uit registreren, verhuizen, verlengen en wijzigen.
- Registratie: Hoogste prijs wordt gekozen uit registreren, verlengen en wijzigen.
- De verkoopprijs wordt als volgt berekend: Kostprijs + €{{default_fee}} + marge - korting.`,
	sections: {
		domain: "Domein validatie",
		general: "Algemene instellingen",
		nameservers: "Nameservers",
		renewal: "Verlengen",
		transfer: "Verhuizen",
	},

	// General settings
	setting_business_only: {
		label: "Alleen zakelijke domeinhouder?",
	},
	setting_dns_sec_enabled: {
		label: "DNS-sec aanwezig?",
	},
	setting_local_presence: {
		label: "Local presence vereist?",
	},
	setting_local_presence_country: {
		label: "In welk land is dit van toepassing?",
	},
	setting_lock_enabled: {
		label: "Lock aanwezig?",
	},
	title: "Domein instellingen",
	transfer_code_max_length: {
		label: "Maximaal aantal karakters",
		placeholder: "Maximaal aantal karakters transfercode",
	},
	transfer_code_min_length: {
		label: "Minimaal aantal karakters",
		placeholder: "Minimaal aantal karakters transfercode",
	},

	// TRANSFER
	transfer_domain_code_required: {
		label: "Verhuiscode verhuizen domein",
	},
	transfer_holder_code_required: {
		label: "Verhuiscode wijzigen domeinhouder",
	},
};

const domainHolderSettings = {
	company_coc_number_required: {
		label: "KvK-nummer verplicht?",
	},
	company_trademark_country_required: {
		label: "Trademark land verplicht?",
	},
	company_trademark_name_required: {
		label: "Trademark verplicht?",
	},
	company_trademark_number_required: {
		label: "Trademark nummer verplicht?",
	},
	description: "Wijzig hier de instellingen voor het domein",
	person_admin_required: {
		label: "Admin privé persoon?",
	},
	person_birth_country_required: {
		label: "Geboorteland verplicht",
	},
	person_birth_date_required: {
		label: "Geboortedatum verplicht",
	},
	person_birth_place_required: {
		label: "Geboorteplaats verplicht",
	},
	person_birth_place_zip_code_required: {
		label: "Postcode geboorteplaats verplicht",
	},
	person_email_verification: {
		label: "E-mailverificatie domeinhouder vereist?",
	},
	person_full_given_name_required: {
		label: "Volledige voornaam verplicht",
	},
	person_id_issue_date_required: {
		label: "ID uitgiftedatum verplicht",
	},
	person_id_issuer_required: {
		label: "ID uitgever verplicht",
	},
	person_id_number_required: {
		label: "ID-nummer verplicht",
	},
	person_tech_required: {
		label: "Tech privé persoon?",
	},
	title: "Domein houder instellingen",
};

const infoSection = {
	description: "Beschrijf hier de algemene product informatie",
	description_field: {
		label: "Omschrijving",
		placeholder: "Geef het product een omschrijving",
	},
	hostfact_product_code: {
		label: "HostFact product code",
		placeholder: "Geef hier het HostFact product nummer op",
	},
	is_default_alternative: {
		label: "Tonen als alternatief domein",
		tooltip:
			"Als dit het geval is, zal het betreffende domein verschijnen als een suggestie wanneer domeinnamen worden gevonden, en het zal ook verschijnen als een zoekresultaat in de zoekbalk als de zoekopdracht niet eindigt met een herkenbare extensie.",
	},
	name_de: {
		label: "Productnaam (Duits)",
		placeholder: "Geef het product een naam (Duits)",
	},
	name_en: {
		label: "Productnaam (Engels)",
		placeholder: "Geef het product een naam (Engels)",
	},
	name_nl: {
		label: "Productnaam (Nederlands)",
		placeholder: "Geef het product een naam ",
	},
	title: "Product informatie",
	tld: {
		label: "Domein extensie",
		placeholder: "com (voorbeeld)",
		tooltip: "Geef de domein extensie op ZONDER een '.' - Voorbeeld: NL",
	},
};

const messages = {
	success_create: "Domein product succesvol aangemaakt!",
	success_delete: "Domein product <strong>{{name}}</strong> succesvol verwijderd!",
	success_disconnect: "Domein succesvol verwijderd uit product groep!",
	success_update: "Domein product succesvol gewijzigd!",
};

const priceSection = {
	checkbox_price_enabled: "Prijs beschikbaar voor domein",
	description: "Hier bevinden zich de prijsgegevens.",
	margin: {
		label: "Marge (%)",
		placeholder: "Bijv. 10%",
	},
	margin_default: {
		label: "Standaard Marge (%)",
		placeholder: "Bijv. 10%",
	},
	margin_type: {
		label: "Margin type",
		options: ["Standaard", "Marge", "Adviesprijs"],
	},
	price_purchase: {
		label: "Kostprijs (€)",
		placeholder: "Bijv. €9,99",
	},
	price_recommended: {
		label: "Adviesprijs (€)",
		placeholder: "Bijv. €19,99",
	},
	price_sell: {
		label: "Verkoop prijs(€)",
		label_help:
			"Dit is de prijs die de klant ziet in het aanvraag formulier, deze prijs wordt niet opgeslagen maar altijd uitgerekend op basis van ingestelde margin type.",
		label_info: "Berekende verkoopprijs: Kostprijs + €{{default_fee}} + marge - korting",
		placeholder: "Bijv. €19,99",
	},
	title: "Prijs informatie",
};

const radioValues = {
	available: "Beschikbaar",
	no: "Nee",
	not_present: "Niet aanwezig",
	not_required: "Niet verplicht",
	present: "Aanwezig",
	required: "Verplicht",
	unavailable: "Niet beschikbaar",
	yes: "Ja",
};

const selectValues = {
	nameservers: "Nameserver(s)",
	year: "Jaar",
};

const table = {
	delete_dialog: {
		description: "Weet je zeker dat je <strong>{{extension}}</strong> wilt verwijderen?",
		title: "Domein product verwijderen",
	},
	disconnect_dialog: {
		description:
			"Wilt u domein <strong>{{name}}</strong> echt verwijderen uit product groep <strong>{{product_group}}</strong>?",
		title: "Domein ontkoppelen",
	},
	extension: "Extensie",
	no_result: "Geen resultaten",
	price_change_owner: "Houderswijziging",
	price_edit: "Wijzigen",
	price_quarantaine: "Quarantaine",
	price_register: "Registreren",
	price_renew: "Verlengen",
	price_transfer: "Verhuizen",
	price_trustee: "Trustee",
	setting_dns_sec_enabled: "DNS sec",
	setting_lock_enabled: "Lock",
	setting_quarantaine_enabled: "Quarantine",
	transfer_domain_code_required: "Verhuiscode nodig",
};

const product_domain = {
	domain_holder_settings: domainHolderSettings,
	domain_settings: domainSettings,
	info_section: infoSection,
	messages: messages,
	price_section: priceSection,
	radio_values: radioValues,
	select_values: selectValues,
	table: table,
};

export default product_domain;
